import { render, staticRenderFns } from "./DeductionPrompt.vue?vue&type=template&id=7b28fe9b&scoped=true"
import script from "./DeductionPrompt.vue?vue&type=script&lang=js"
export * from "./DeductionPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28fe9b",
  null
  
)

export default component.exports